<template>
    <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen p-4">
            <div class="bg-white w-full max-w-md rounded-lg shadow-xl p-6 relative">
                <button
                    @click="closeModal"
                    class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                >
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h3 class="text-2xl font-semibold text-gray-800 mb-4">
                    Interview Details
                </h3>
                 <div v-if="interview">
                     <p class="text-gray-700 mb-2"><strong>Date:</strong> {{ new Date(interview.interviewDate._seconds * 1000).toLocaleString() }}</p>
                    <p class="text-gray-700 mb-2"><strong>Interviewer ID:</strong> {{ interview.interviewerId }}</p>
                     <p class="text-gray-700 mb-2"><strong>Overall Analysis:</strong> {{ interview.overall }}</p>
                      <p class="text-gray-700 mb-2"><strong>Score:</strong> {{ interview.score }}</p>
                    <div v-if="interview.transcription">
                        <p class="text-gray-700 mb-2"><strong>Transcription:</strong></p>
                        <pre class="text-sm text-gray-800 whitespace-pre-wrap break-words">{{ interview.transcription }}</pre>
                    </div>
                    <div v-if="interview.feedback">
                         <p class="text-gray-700 mb-2"><strong>Feedback:</strong></p>
                          <pre class="text-sm text-gray-800 whitespace-pre-wrap break-words">{{ interview.feedback }}</pre>
                    </div>
                 </div>
                  <div v-else>
                    <p class="text-gray-700 mb-2">Interview information not available.</p>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: Boolean,
        interview: Object,
    },
    methods: {
        closeModal() {
            this.$emit("close");
            this.$emit("status-updated");
        },
    },
};
</script>